import React, { Component } from 'react';
import { config, SERVICE_API, VIEW_NAME, DISPATCH_ID } from "../libs/utils/Const";
import CurrencyFormat from 'react-currency-format';
import { connect } from "react-redux";
import '../index.css';
import $ from 'jquery';
import { ApiClient } from "../libs/apiClient/ApiClient";
import ReactTooltip from 'react-tooltip';
import Tooltip from 'react-light-tooltip'
import Popover from 'react-bootstrap/Popover'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import {Promociones} from '../components/index';


let apiClient = ApiClient.getInstance();


class ShoppingCartList extends Component {
    state = {
        promo: [],
        itemPromo:[],
        promociones:[],
        seller: JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser')),
    }

    componentDidMount = async () => {
        $(document).ready(function(){
            $('[data-toggle="popover"]').popover();
        });
        await this.cargarDatos();
    };

    cargarDatos = async () => {
        const {activarboton} = this.props;
        let user = localStorage.getItem(config.general.localStorageNamed + 'CurrentUser');
        user = JSON.parse(user) || {};
        let datos ={
            CardCode : user.CardCode,
            Canal : user.U_SYP_RICO_CCANAL,
            Region : user.U_SYP_RICO_CREGION,
            SubCanal : user.U_SYP_RICO_CSBCAN,
            Sucursal : user.U_SYP_RICO_CSUCUR,
        }
        let newdatas = await apiClient.getPromo(datos);
        // console.log('con<<<****',newdatas);
        if(newdatas.status !== 1){
           return;
        }
        if(newdatas.data.length > 0){
            this.setState({
                promociones: newdatas.data,
            });
            await this.validateDisparador();
        }
        activarboton();
    };

    validateDisparador = async () => {
        const {promociones} = this.state;
        const {enableSpinner, data ,refeshState} = this.props;
        
        //#region   ##########---DECLARACION DE VARIABLES----###################
        let arrayPromoVol = [];
        let notificacionIems = [];
        let itemsNotificacion = [];
        let promoECD = [];
        let promoEDC = [];
        let promoE = [];
        let arrayRelacional = [];
        let itemsBonificacion =  {};
        let itemsPromo = [];
        //#endregion

        //#region ##########---VALIDA ARTICULOS POR TIPO DE DISPARADOR----###################

        for (let index = 0; index < promociones.length; index++) {//----recorremos todas las promociones
            const promo = promociones[index]; //cada promocion se guarda en promo
            let arrayItems = [];
            for (let index = 0; index < promo.length; index++) {//----Articulos por promoción
                const disparador = promo[index];
                if (disparador.fkTipoDisparador === 1) {  //---VOLUMEN--------------------------------
                    for (let index = 0; index < data.length; index++) {//----Articulos por promoción
                        const item = data[index];
                        if (item.ItemCode === disparador.idProducto) {
                            arrayItems.push(disparador);
                        }
                    };
                }else if (disparador.fkTipoDisparador === 2) { //--------------------------------MONTO--------------------------------

                }
            }
            if(arrayItems.length > 0){
                arrayPromoVol.push(arrayItems);
            }
        }
        //#endregion
        
        //#region ##########---DISPARADOR TIPO VOLUMEN VALIDA SUBTIPO----###################

        for (let index = 0; index < arrayPromoVol.length; index++) {
            const itemsPromo = arrayPromoVol[index];
            for (let index = 0; index < itemsPromo.length; index++) {
                const item = itemsPromo[index];
                if (item.fkSubTipo === 1) {  //---En la compra de--------------------------------
                    promoECD.push(itemsPromo);
                    break;
                } else if (item.fkSubTipo === 2) {//---En la compra decualquera de--------------------------------
                    promoEDC.push(itemsPromo);
                    break;
                }else if (item.fkSubTipo === 3) {//---Escalas--------------------------------
                    promoE.push(itemsPromo);
                    break;
                }
            }
        }
        //#endregion
        
        //#region ##########--- ESCALAS, VALIDA STOCK----###################

        for (let index = 0; index < promoE.length; index++) {
            const promo = promoE[index];
            let sumTotal = 0;
            let newAarrayE = []
            let hash = {};
            newAarrayE = promo.filter((current) => {
                let exists = !hash[current.idProducto];
                hash[current.idProducto] = true;
                return exists;
            });
            for (let index = 0; index < newAarrayE.length; index++) {
                const element = newAarrayE[index];
                for (let index = 0; index < data.length; index++) {
                    const item = data[index];
                    if(item.ItemCode === element.idProducto){
                        sumTotal+=parseInt(item.quantity,10);
                    }
                }
            }
            let filter = promo.filter((item)=> item.idProducto === promo[0].idProducto);
            filter = filter.sort(((a, b) => a.cantidad - b.cantidad));
            
            let item = null;
            for (let index = 0; index < filter.length; index++) {
                const elementPromo = filter[index];
                if(sumTotal >= elementPromo.cantidad){
                    item = elementPromo;
                }
            }
            if(item){
                itemsPromo.push(item);
            }
        }
        //#endregion

        //#region ##########--- EN LA COMPRA DE, VALIDA STOCK----###################

        for (let index = 0; index < promoECD.length; index++) {
            const promo = promoECD[index];
            for (let index = 0; index < promo.length; index++) {
                const element = promo[index];
                for (let index = 0; index < data.length; index++) {
                    const item = data[index];
                    if((parseInt(item.quantity,10) >= element.cantidad) && (item.ItemCode === element.idProducto)){
                        element.newQuantity = parseInt(parseInt(item.quantity,10) / element.cantidad);
                        itemsPromo.push(element);
                    }
                }
            }
        }
        //#endregion
        
        //#region ##########--- EN LA COMPRA DE CUALQUIERA DE, VALIDA STOCK  ----###################

        for (let index = 0; index < promoEDC.length; index++) {
            const promo = promoEDC[index];
            let sumTotal = 0;

            for (let index = 0; index < promo.length; index++) {
                const element = promo[index];

                for (let index = 0; index < data.length; index++) {
                    const item = data[index];

                     if(item.ItemCode === element.idProducto){
                        sumTotal+=parseInt(item.quantity,10);
                     }

                }
            }
            if(sumTotal >= promo[0].cantidad){
                for (let index = 0; index < promo.length; index++) {
                    const elementPromo = promo[index];
                    elementPromo.newQuantity = parseInt(sumTotal / promo[0].cantidad);
                    itemsPromo.push(elementPromo);
                }
            }
        }
        //#endregion

        //#region ##########--- ASIGNACION DE BONIFICACION POR STOCK  ----###################

        if(itemsPromo.length > 0){
            enableSpinner(true);
                itemsBonificacion = await apiClient.getBonificacion(itemsPromo);
            enableSpinner(false);
            if(itemsBonificacion.data.length > 0){
                for (let index = 0; index < itemsPromo.length; index++) {
                    const itemsList = itemsPromo[index];

                    for (let index = 0; index < itemsBonificacion.data.length; index++) {
                        const bonificacionList = itemsBonificacion.data[index];

                        for (let index = 0; index < bonificacionList.length; index++) {
                            const element = bonificacionList[index];
                            if(itemsList.bonificacion === element.bonificacion && itemsList.relacion === element.relacion){
                                let promo ={
                                    itemDisparador: itemsList.idProducto,
                                    tipoDisparador: itemsList.fkSubTipo,
                                    bonificacion : element,
                                    tipoSeleccion: element.idTipoSeleccion,
                                    use : false,
                                    idDisparador: element.disparador,
                                    itemQuantity: itemsList.cantidad ,
                                    homeItemQuantity: itemsList.newQuantity,
                                }
                                arrayRelacional.push(promo);
                            }
                        }

                    }
                }

            }
        }
        //#endregion
       
        //#region ##########---ARREGLO PARA NORIFICAR BONIFICACIONES----###################

        if(arrayPromoVol.length > 0){
            let itemsPromo = [];

            let bonifNoti =[];
            for (let index = 0; index < arrayPromoVol.length; index++) {
                const promociones = arrayPromoVol[index];
                for (let index = 0; index < promociones.length; index++) {
                    const item = promociones[index];
                    itemsPromo.push(item);
                }
            }
            enableSpinner(true);
            bonifNoti = await apiClient.getBonificacion(itemsPromo);
            enableSpinner(false);
            for (let index = 0; index < itemsPromo.length; index++) {
                const element = itemsPromo[index];
                const result = notificacionIems.find(itemDisp => itemDisp.idProducto === element.idProducto);
                if(!result){
                    notificacionIems.push(element);
                }
            }

            if(bonifNoti.data.length > 0){
                for (let index = 0; index < itemsPromo.length; index++) {
                    const item = itemsPromo[index];
                    let notificacion ={
                        itemDisparador: item.idProducto,
                        tipoVenta: item.fkSubTipo,
                        bonificacion : [],
                        idDisparador: item.disparador,
                        itemQuantity: item.cantidad,
                    }
                    for (let index = 0; index < bonifNoti.data.length; index++) {
                        const element = bonifNoti.data[index];
                        let itemsTemp = [];
                        for (let index = 0; index < element.length; index++) {
                            const bonificacion = element[index];
                            if(item.disparador === bonificacion.disparador && item.relacion === bonificacion.relacion){
                                itemsTemp.push(bonificacion);
                            }
                        }

                        let items = [];
                        let registrados = [];
                        for (let index = 0; index < itemsTemp.length; index++) {
                            const element = itemsTemp[index];
                            let include = registrados.includes(element.indexPack);
                            if(!include){
                                let arrayTemp = itemsTemp.filter(item => (item.indexPack === element.indexPack));
                                registrados.push(element.indexPack);
                                items.push(arrayTemp);
                            }
                        } 
                        if(itemsTemp.length > 0){
                            notificacion.bonificacion = items;
                        }
                    }
                    itemsNotificacion.push(notificacion);
                }

                for (let index = 0; index < notificacionIems.length; index++) {
                    const element = notificacionIems[index];
                    let notificacion =[];
                    for (let index = 0; index < itemsNotificacion.length; index++) {
                        const promo = itemsNotificacion[index];
                        if(element.idProducto === promo.itemDisparador){
                            notificacion.push(promo);
                        }
                    }
                    element.notificacion = notificacion;
                }
            }
        }
        //#endregion
        
        await refeshState(arrayRelacional,notificacionIems);
    };

    changeQuantity = async (index, item, event) => {
        const { changeQuantity } = this.props;
        let newQuantity = event.nativeEvent.target.value;
        let onHand = item.OnHand;

        if (newQuantity > onHand) {
            newQuantity = onHand;
        }

        let user = localStorage.getItem(config.general.localStorageNamed + 'CurrentUser');
        user = JSON.parse(user) || {};

        let data = {
            CardCode: user.CardCode
        }

        await apiClient.getDescuento(data).then(result => {
            this.setState({
                promo: result.data
            })
        });

        // color azul rinti
        // console.log('con<<<', index, item.ItemCode);
        document.getElementById(item.ItemCode).style.backgroundColor = "#005DA8";
        document.getElementById(item.ItemCode).style.borderColor = "#005DA8";

        changeQuantity(index, item, newQuantity, true); // add
        this.validateDisparador();
    };
    

    //BOTON AGREGAR AL CARRITO

    changLocalQuantity = (index, item, event)=>{
        const {shoppingCartReducer: { items },setShoppingCart } = this.props;
        let newQuantity =  event.nativeEvent.target.value;
        if(newQuantity < 0){
            newQuantity = 1
        }
        if (newQuantity % 1 == 0) {
            items.map( itemLocal => {
                if (itemLocal.ItemCode === item.ItemCode) {
                    itemLocal.quantity = newQuantity;
                }
            });
             // color success
            document.getElementById(item.ItemCode).style.backgroundColor = "#28a745"; 
            document.getElementById(item.ItemCode).style.borderColor = "#28a745"; 
            setShoppingCart(items);
        }
        else{
            return;
        }
        
    }
    
    //////////////////////////

    validateQuantity = (index, item, e) => {
        if (!e.target.value) {
            let event = {
                nativeEvent: {
                    target: {
                        value: 1,
                    }
                }
            };
            this.changeQuantity(index, item, event);
        }
    };

    validateStock = item => {
        if ((item.quantity > item.OnHand) && !!item.OnHand) {
            return (
                <div className='col-12' style={{ color: 'red', fontSize: 15, padding: 0 }}>
                    La cantidad seleccionada excede la existencia.
                </div>
            )
        }
    };

    validateStockBonificacion = item => {
        if (item.Stock <= 0) {
            return (
                <div className='col-12 font-weight-bold ' style={{ color: 'red', fontSize: 15, padding: 0 }}>
                    El artículo no tiene stock para la bonificación.
                </div>
            )
        }
        if (item.cantidad > item.Stock) {
            return (
                <div className='col-12 font-weight-bold ' style={{ color: 'red', fontSize: 15, padding: 0 }}>
                    El artículo no tiene suficiente stock para la bonificación.
                </div>
            )
        }
        
    };

    deleteItemLocal = async ({ item = null, deleteAll = null })=>{
        const {deleteItem} = this.props;
        await deleteItem({ item, deleteAll: false });
        this.validateDisparador();


    };

    renderBonificaciones =(element,ItemCode)=>{
        const {deleteItemPromo} = this.props;
        const {seller} = this.state;
        let itemRegalo = element.bonificacion;
        if(ItemCode === element.itemDisparador){
            return (
                <div className='row' style={{ padding: 10, textAlign: 'center' }}>
                    <div className='col-sm-2' style={{ margin: 0 }}>
                    <img
                        className="img-fluid "
                        style={{
                            backgroundColor: 'white',
                            maxHeight: 130
                        }}
                        src={itemRegalo.PicturName ? (config.BASE_URL + SERVICE_API.getImage + '/' + itemRegalo.PicturName) : require('../images/noImage.png')}
                        alt=""
                    />
                    </div>
                    <div className='col-sm-10'>
                        <div className="container p-0">
                            <div className="row">
                                <div className="col-12" style={{ borderBottom: '1px solid rgb(124, 124, 125)' }}>
                                    <div className='text-left'>
                                        {itemRegalo.ItemName}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                        <div className="col-md-12 table-responsive">
                            <table class="table">
                                <thead>
                                    <tr >
                                        <th scope="col">Código</th>
                                        <th scope="col">Cantidad</th>
                                        {seller ? seller.U_FMB_Handel_Perfil != '0' ? 
                                            <th scope="col"></th>
                                            : "" : ""
                                        }
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                <td>
                                    <i className="fa fa-gift" data-toggle="tooltip"  title={'Artículo de regalo'} style={{ cursor: 'pointer', paddingRight:"5px", color:'#005DA8' }}/>
                                    {itemRegalo.idProducto}
                                </td>
                                    <td>

                                        <input
                                            disabled={true}
                                            id={'input-quantity-' + itemRegalo.idProducto + 1}
                                            type="number"
                                            min="1"
                                            value={itemRegalo.cantidad ? Number(itemRegalo.cantidad) : ''}
                                            className="form-control"
                                            name={'quantity' + itemRegalo.idProducto}
                                            placeholder="Cantidad"
                                            style={{ textAlign: 'center' }}/>
                                    </td>

                                    <td>
                                        { itemRegalo.idTipoSeleccion === 2 &&
                                            <i className="fa fa-trash" style={{ cursor: 'pointer' }} onClick={() => deleteItemPromo(element)} />}
                                    </td>
                                    {seller ? seller.U_FMB_Handel_Perfil != '0' ? 
                                        <td>
                                            {this.validateStockBonificacion(itemRegalo)}
                                        </td>
                                        : "" : ""
                                    }
                                    <td></td>
                                </tbody>

                            </table>

                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            )
        }
    };

    renderBoxesProm = (itemPromo,itemCode) =>{
        const {selectItemsPromo} = this.props;
        if((itemPromo.itemDisparador ===  itemCode)  &&  itemPromo.tipoSeleccion === 2 ){
            return  (
                    <i className="fas fa-box-open" data-toggle="tooltip"  title={itemPromo.bonificacion.nombre} style={{ cursor: 'pointer', paddingRight:"5px", color:'#28a745', fontSize: 'x-large' }} onClick = {() => selectItemsPromo(itemPromo,itemCode)} />
            )
       }
    };

    render() {
        const { data, view,deleteItemPromo, sendTo, itemsReducer: { addShoppingCart, deleteShoppingCart }, shoppingCartReducer: { items },itemPromociones ,selectItemsPromo,itemsRegalos,itemsRegalosSelect,itemDisparador,boxes,itemsNotificacion} = this.props;
        const {seller} = this.state;
        // console.log('con< data', data);
        return (
            <div>
                {data.map((item, index) => {
                    // console.log('con<<<<<<<<<<<<<', item, item.priceTax);//parseFloat(item.Price - (item.Price * (item.Discount / 100)) + (item.Price * (item.taxRate / 100))).toFixed(2));
                    return (
                        <div key={index} className=' text-left card ' style={{ border: 'none' }}>
                            <div className='row' style={{ padding: 10, textAlign: 'center' }}>

                                {!(!!item.OnHand) && <div className='col-12' style={{
                                    marginBottom: 5,
                                    padding: 5,
                                    backgroundColor: config.navBar.backgroundColor, color: config.navBar.textColor
                                }}>
                                    Agotado
                                </div>}
                                <div className='col-sm-2' style={{ margin: 0 }}>
                                    <img
                                        className="img-fluid "
                                        style={{
                                            backgroundColor: 'white',
                                            maxHeight: 130,
                                        }}
                                        src={item.PicturName ? (config.BASE_URL + SERVICE_API.getImage + '/' + item.PicturName) : require('../images/noImage.png')}
                                        alt=""
                                    />
                                   {itemsNotificacion.map((element)=>{
                                    //    console.log('con>',item.ItemCode, element.idProducto);
                                        return (
                                            <div className="input-group details">
                                                {/* <div className='input-group-prepend' style={{width: 40,cursor: 'pointer', alignItems: 'center'}} >
                                                    <img align='middle' style={{width:20, height:20}} src='https://www.flaticon.com/svg/vstatic/svg/726/726476.svg?token=exp=1611777984~hmac=57fc38fc974f464a6dc26404a4c3f5ea'/>
                                                </div>  */}
                                                {item.ItemCode === element.idProducto &&
                                                <Promociones
                                                itemsNotificacion = {element.notificacion}/>}
                                            </div>
                                        )})
                                    }
                                </div>

                                <div className='col-sm-10'>
                                    <div className="container p-0">
                                        <div className="row">
                                            <div className="col-12" style={{ borderBottom: '1px solid rgb(124, 124, 125)' }}>
                                                <div className='text-left'>
                                                    {item.ItemName}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {/* <div className="col-2 p-0 pt-2 font-italic">
                                                {item.ItemCode}
                                            </div> */}
                                            <div className="col-md-12 table-responsive">
                                                <table class="table">
                                                    <thead>
                                                        <tr >
                                                            <th scope="col">Código</th>
                                                            <th scope="col">Cantidad</th>
                                                            {seller ? seller.U_FMB_Handel_Perfil != '0' ? 
                                                                <th scope="col">Cant. Disponible</th>
                                                                : "" : ""
                                                            }
                                                            <th scope="col">Precio unitario</th>
                                                            <th scope="col">Descuento</th>
                                                            <th scope="col">Precio total</th>
                                                            <th scope="col">Peso neto</th>
                                                            <th scope="col">Peso bruto</th>
                                                            <th scope="col"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td>
                                                        {item.ItemCode}
                                                    </td>
                                                        <td>
                                                            <input
                                                                disabled={!(!!item.OnHand)}
                                                                id={'input-quantity-' + item.ItemCode + index}
                                                                type="number"
                                                                min="1"
                                                                value={item.quantity ? Number(item.quantity) : ''}
                                                                className="form-control"
                                                                name={'quantity' + item.ItemCode}
                                                                placeholder="Cantidad"
                                                                style={{ textAlign: 'center' }}
                                                                onChange={(event) => {  this.changLocalQuantity(index, item, event) }}
                                                                onBlur={(e) => this.validateQuantity(index, item, e)} />

                                                            <button type="button" //disabled={item.OnHand >=1 ? false : item.OnHand === '0.0' ? true : true } 
                                                                className="btn btn-success btn-block" 
                                                                disabled={!(!!item.OnHand)}
                                                                value={(item.quantity ? Number(item.quantity): '1')} 
                                                                onClick={(event)=>{this.changeQuantity(index, item, event)}}
                                                                id={item.ItemCode}
                                                                style={{backgroundColor : item.quantity != '' ?  '#005DA8' : '', borderColor : item.quantity != '' ?  '#005DA8' : ''}}
                                                                >
                                                                <i className={config.icons.add}/> Actualizar carrito
                                                            </button>
                                                        </td>
                                                        {seller ? seller.U_FMB_Handel_Perfil != '0' ? 
                                                            <td>
                                                                {item.OnHand}
                                                            </td>
                                                            : "" : ""
                                                        }
                                                        <td>
                                                            <CurrencyFormat
                                                                // value={item.Price}
                                                                value={item.priceTax}
                                                                displayType={'text'}
                                                                thousandSeparator={true}
                                                                fixedDecimalScale={true}
                                                                decimalScale={2}
                                                                prefix={config.general.currency}>
                                                            </CurrencyFormat>
                                                        </td>

                                                        <td>
                                                            {item.Discount === null || item.Discount === ''? '0 %' : parseFloat(item.Discount).toFixed(2) + ' %'}
                                                        </td>

                                                        <td>
                                                            <CurrencyFormat
                                                                // value={item.Price * item.quantity - (item.Price * item.quantity * (item.Discount / 100))}
                                                                // value={item.Price * item.quantity - (item.Price * item.quantity * (item.Discount / 100)) + (item.Price * item.quantity * (item.taxRate / 100))}
                                                                value={item.priceTax * item.quantity}
                                                                displayType={'text'}
                                                                thousandSeparator={true}
                                                                fixedDecimalScale={true}
                                                                decimalScale={2}
                                                                prefix={config.general.currency}>
                                                            </CurrencyFormat>
                                                        </td>

                                                        <td>
                                                            {parseFloat(item.quantity * item.weight).toFixed(2) + ' KG'}
                                                        </td>

                                                        <td>
                                                            {parseFloat(item.quantity * item.weight1).toFixed(2) + ' KG'}
                                                        </td>

                                                        <td>
                                                            {item.quantity &&
                                                                <i className="fa fa-trash" style={{ cursor: 'pointer' }} onClick={() => this.deleteItemLocal({ item, deleteAll: false })} />}
                                                            {this.validateStock(item)}

                                                        </td>
                                                        <td></td>
                                                    </tbody>

                                                </table>

                                            </div>
                                            <div className="col-md-12" >
                                                {itemsRegalos.map((elemenet)=>{return this.renderBonificaciones(elemenet,item.ItemCode)})}
                                                {itemsRegalosSelect.map((elemenet)=>{return this.renderBonificaciones(elemenet,item.ItemCode)})}

                                             </div>

                                             <div className="col-md-12" >
                                                {boxes.map((itemPromo, index) => { return this.renderBoxesProm(itemPromo,item.ItemCode)})}
                                             </div>
                                            </div>
                                    </div>
                                    {/* {!(!!item.OnHand) && <div className='row text-center'
                                        style={{ margin: 0, padding: 0 }}>
                                        <div className='col-2' style={{
                                            color: item.OnHand ? 'rgb(13, 98, 168)' : 'rgb(124, 124, 125)',
                                            fontSize: 30,
                                            padding: 0
                                        }}>
                                        </div>
                                        <div className='col-8' style={{ marginTop: 10 }}>
                                             Mover a lista de deseos 
                                            Lista de SOLICITUD
                                        </div>
                                        <div className='col-2'
                                            style={{ color: config.navBar.backgroundColor, fontSize: 30, padding: 0 }}>
                                            {item.quantity && <i className="fa fa-plus" style={{ cursor: 'pointer' }}
                                                onClick={() => sendTo(item)} />}

                                        </div>
                                    </div>} */}

                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        itemsReducer: store.ItemsReducer,
        shoppingCartReducer: store.ShoppingCartReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
        setShoppingCart: value => dispatch({ type: DISPATCH_ID.SHOPPING_CART_SAVE_CART, value }),
        
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShoppingCartList);